import { FEATURES } from "@stacc/flow-case-manager";
import { searchProcesses, searchFields, searchResultFields } from "./search-configuration-const";

export const searchConfiguration = {
  features: [FEATURES.CaseNotes],
  searchProcesses: searchProcesses,
  searchQueryView: "caseworker-search-result",
  search: {
    fields: searchFields,
    sort: [
      {
        name: "Recently changed",
        value: "updatedAt",
        direction: "desc",
      },
      { name: "Oldest", value: "createdAt", direction: "asc" },
      { name: "Newest", value: "createdAt", direction: "desc" },
    ],
  },
  searchResults : {
    fields: searchResultFields
  },
  disableSearchHitCount: true /* Default is false*/ 
}

